export const SliderData = [
  {
    image:
  ' https://m.media-amazon.com/images/I/71dbxIcDioL._SX3000_.jpg'
 },
 {
  image:
'https://images-na.ssl-images-amazon.com/images/I/71tIrZqybrL._SX3000_.jpg'
},
  {
     image:
   ' https://images-na.ssl-images-amazon.com/images/G/01/AmazonExports/Fuji/2020/May/Hero/Fuji_TallHero_Beauty_v2_en_US_1x._CB429089975_.jpg'
  },
  {
    image :
      'https://images-eu.ssl-images-amazon.com/images/G/02/digital/video/merch2016/Hero/Covid19/Generic/GWBleedingHero_ENG_COVIDUPDATE__XSite_1500x600_PV_en-GB._CB428684220_.jpg'
  },
  {
    image:
      'https://images-na.ssl-images-amazon.com/images/G/01/AmazonExports/Fuji/2020/May/Hero/Fuji_TallHero_Toys_en_US_1x._CB431858161_.jpg'
  },
  {
    image:
      'https://images-na.ssl-images-amazon.com/images/G/01/AmazonExports/Events/2020/Holiday/GiftGuide/Fuji_TallHero_GG2_en_US_1x._CB418256337_.jpg'
  },
];
